import React, { useState } from "react";
import { styled } from "~/ui/style/stitches.config";
import { Button } from "~/ui/components/Button";

interface BirthdayCollectionProps {
  onSubmit: (birthday: Date) => void;
  onSkip?: () => void;
}

export const BirthdayCollection = ({ onSubmit, onSkip }: BirthdayCollectionProps) => {
  const [month, setMonth] = useState<string>("");
  const [day, setDay] = useState<string>("");
  const [year, setYear] = useState<string>("");
  const [error, setError] = useState<string>("");

  const months = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  // Generate days 1-31
  const days = Array.from({ length: 31 }, (_, i) => (i + 1).toString());

  // Generate years (current year - 100 to current year - 13 for COPPA compliance)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 88 }, (_, i) => (currentYear - 13 - i).toString());

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!month || !day || !year) {
      setError("Please select your birthday");
      return;
    }

    // Validate the date is real
    const selectedDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    if (
      selectedDate.getMonth() !== parseInt(month) - 1 ||
      selectedDate.getDate() !== parseInt(day)
    ) {
      setError("Please enter a valid date");
      return;
    }

    onSubmit(selectedDate);
  };

  return (
    <Container className="birthday-collection-container">
      <Title>Excited you're here!</Title>

      <Form onSubmit={handleSubmit}>
        <Label>When were you born? 🕯️</Label>
        <DatePickerRow>
          <Select
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            placeholder="Month"
          >
            <option value="" disabled>
              Month
            </option>
            {months.map((m) => (
              <option key={m.value} value={m.value}>
                {m.label}
              </option>
            ))}
          </Select>

          <Select value={day} onChange={(e) => setDay(e.target.value)} placeholder="Day">
            <option value="" disabled>
              Day
            </option>
            {days.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </Select>

          <Select value={year} onChange={(e) => setYear(e.target.value)} placeholder="Year">
            <option value="" disabled>
              Year
            </option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </Select>
        </DatePickerRow>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <Button type="submit" formButton>
          Continue
        </Button>
      </Form>
    </Container>
  );
};

const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: "36px 0",
  maxWidth: "425px",
  width: "90%",
  backgroundColor: "white",
  border: "1px solid black",
  borderRadius: "45px",
  boxShadow: "0px 3px 0px 0px #000000",
});

const Title = styled("h3", {
  fontWeight: "500",
  fontSize: "16px",
  fontFamily: "WorkSans",
  marginBottom: "18px",
});

const Form = styled("form", {
  display: "flex",
  flexDirection: "column",
  width: "270px",
});

const Label = styled("p", {
  fontSize: "13px",
  fontFamily: "WorkSans",
  marginBottom: "20px",
  textAlign: "center",
  color: "$gray600",
});

const DatePickerRow = styled("div", {
  display: "flex",
  gap: "8px",
  marginBottom: "16px",
});

const Select = styled("select", {
  flex: 1,
  height: "45px",
  border: "1px solid #B6B6B6",
  borderRadius: "14px",
  padding: "0 12px",
  fontSize: "13px",
  backgroundColor: "white",
  cursor: "pointer",
  textAlign: "center",
  textAlignLast: "center",

  "&:focus": {
    outline: "none !important",
    borderColor: "black",
  },

  "&:invalid": {
    color: "#999",
  },
});

const ErrorMessage = styled("p", {
  color: "$error",
  fontSize: "9px",
  marginBottom: "12px",
  marginTop: "-8px",
  textAlign: "left",
  marginLeft: "8px",
});

